// from https://stackoverflow.com/questions/9267899/arraybuffer-to-base64-encoded-string
export function arrayBufferToBase64(buffer: ArrayBuffer) {
  let binary = '';
  const bytes = new Uint8Array(buffer);
  const len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return window.btoa(binary);
}

export function filterArray(key: string, array: string[] | undefined): string[] {
  let not = false;
  if (key?.startsWith('!')) {
    not = true;
    key = key?.substring(1);
  }

  return (array || []).filter((t) => {
    const found = t.startsWith(key);
    return not ? !found : found;
  });
}

export function timeoutPromise(timeoutMs: number) {
  return new Promise<undefined>((_, reject) => {
    setTimeout(() => reject(new Error('Request timed out')), timeoutMs);
  });
}

export function generateRandomString(length: number): string {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export function getTimeOfDayGreeting(): string {
  const currentHour = new Date().getHours();

  if (currentHour < 12) {
    return 'Good morning';
  } else if (currentHour < 18) {
    return 'Good afternoon';
  } else {
    return 'Good evening';
  }
}

export function isHttp2Available() {
  // This reflects how the browser loaded the page itself
  const navEntries = performance.getEntriesByType('navigation') as PerformanceNavigationTiming[];
  return navEntries[0]?.nextHopProtocol === 'h2';
}

export function toValidNumber(v: unknown): number | undefined {
  if (v === null || v === undefined || v === '') {
    return undefined;
  }
  const n = Number(v);
  return isNaN(n) ? undefined : n;
}
